import { FC, useEffect, useState } from 'react'
import { getAllCameras } from '../../api/live/live'
import useCustomizeLiveStore from '../../store/live/useCustomizeLiveStore'
import { camListArrayType } from '../../types/props/live'
import { SelectPreviewTank } from './SelectTank'

export interface CameraPositionProps {
  groupIds: string[]
}

export const CameraPosition: FC<CameraPositionProps> = ({ groupIds }) => {
  const [splitArray, setSplitArray] = useState<camListArrayType[]>([[]])
  const { setAllCameras, allCamerasMap, cameraGrid, cameraList, setCameraList, setSaveData } =
    useCustomizeLiveStore()

  useEffect(() => {
    if (!allCamerasMap) {
      getAllCameras(setAllCameras)
    }
  }, [setAllCameras, allCamerasMap])

  function splitArrayD(cameraList: camListArrayType, cameraGrid: string[]) {
    const chuncked: camListArrayType[] = []
    let index = 0
    while (index < Number(cameraGrid[0]) * Number(cameraGrid[1])) {
      chuncked.push(cameraList.slice(index, index + Number(cameraGrid[0])))
      index += Number(cameraGrid[0])
    }
    setSplitArray(chuncked)
  }

  useEffect(() => {
    splitArrayD(cameraList, cameraGrid)
    setSaveData()
  }, [cameraGrid, cameraList, setSaveData])

  return (
    <div className="camera-position-container">
      {splitArray.map((arr, i) => (
        <div
          key={i}
          className={'flex flex-col md:grid gap-2 p-1'}
          style={{
            gridTemplateColumns: window.innerWidth >= 768 ? `repeat(${cameraGrid[0]}, 1fr)` : '1fr',
          }}
        >
          {arr.map((item, index) => (
            <SelectPreviewTank
              key={i * Number(cameraGrid[0]) + index}
              loc={i * Number(cameraGrid[0]) + index}
              item={item}
              i={i}
              index={index}
              cameraList={cameraList}
              setCameraList={setCameraList}
              groupIds={groupIds}
            />
          ))}
        </div>
      ))}
    </div>
  )
}
